import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { HttpResponse, User } from "@/types";

export const taggableSameCompanyUsersQueryKey = [
  "users",
  "taggable-same-company-users",
] as const;

// TODO need to change this name to useGetAllUsers, as this taggable and company concept doesn't exist anymore
export function useGetTaggableSameCompanyUsers() {
  return useQuery({
    queryKey: taggableSameCompanyUsersQueryKey,
    queryFn: async () => {
      const path = "users/taggable-same-company-users";
      const res = await guacHttpClient.get<User[], HttpResponse<User[]>>(path);
      return res.data;
    },
    // 60sec for user activity
    refetchInterval: 60_000,
  });
}
